module.exports = __webpack_public_path__ + "img/SoftwareCopyright_7.ea351fdb.png";